import { ActivitiesSupport } from '@app/shared/enums/activities-support.enum';
import { PerformanceCategoriesSupport } from '@app/shared/enums/performance-categories-support.enum';
import { QuestionSupport } from '@app/shared/enums/question-support.enum';
import { FormAction } from '@app/shared/enums/form-action.enum';
import { ResponseType } from '@app/shared/enums/response-type.enum';
import { ProgramExitTypeNature } from '@app/shared/enums/program-exit-type-nature.enum';
import { ProgramRole } from '@app/shared/enums/program-role.enum';
import { UserListApiModel } from '../users/UserListApiModel';
import { FormInstanceRatingApiModel } from '../program/shared/form-instances/FormInstanceRatingApiModel';
import { MultipleTraineeActionType } from '@shared/enums';

export class FormInstanceBaseApiModel {
  public Id: number;
  public FormId: number;
  public Name: string;
  public SubjectName: string;
  public SubjectJobTitleName: string;
  public SubjectIdNumber: string;
  public SubjectCADConnectorId: string | null;
  public SubjectProgramRoleId: string;
  public SubjectAvatarSrc: string;
  public SubjectRole: ProgramRole;
  public SubjectUserId: string;
  public TrainerName: string;
  public TrainerNumber: string;
  public CreatorUserId: string;
  public CurrentStepName: string;
  public CurrentStepId: number;
  public CurrentStepResponseType: ResponseType;
  public CreatorProgramRoleId: string;
  public InstanceNumber: string;
  public IsSubmitted: boolean;
  public IsEditable: boolean;
  public IsHeaderEditable: boolean;
  public IsDeletable: boolean;
  public ActivitiesSupport: ActivitiesSupport;
  public PerformanceCategoriesSupport: PerformanceCategoriesSupport;
  public QuestionSupport: QuestionSupport;
  public IsSummary: boolean;
  public IsCritique: boolean;
  public Hours: number;
  public WorkDate: Date;
  public ActualWorkDate: string;
  public MinWorkDate: Date;
  public MaxWorkDate: Date;
  public CreatedDate: Date;
  public PhaseId: number | null;
  public PhaseName: string;
  public ShiftId: number | null;
  public ShiftName: string;
  public LocationId: number | null;
  public LocationName: string;
  public ProgramExitTypeId: number;
  public ProgramExitTypeName: string;
  public ProgramExitTypeNature: ProgramExitTypeNature;
  public CreatorNarrative: string;
  public SubjectNarrative: string;
  public HasCreatorNarrative: boolean;
  public IsSummaryNotesRequire: boolean;
  public HasSubjectNarrative: boolean;
  public IsRejected: boolean;
  public HasRatingRecommendation: boolean;
  public DisplayRelatedPerformanceData: boolean;
  public DisplayHistoryToSubject: boolean;
  public DisplayCategoryAverage: boolean;
  public HasEditorReview: boolean;
  public HasSummarySupportingDocuments: boolean;
  public HasCitizenFeedback: boolean;
  public NextUsers: Array<UserListApiModel>;
  public Ratings: Array<FormInstanceRatingApiModel>;
  public CurrentComment: string;
  public FormAction: FormAction;
  public IsActionable: boolean;
  public IsRejectable: boolean;
  public IsSubjectCompleted: boolean;
  public IsCreatorCompleted: boolean;
  public IsForMultipleTrainee: boolean;
  public MultipleTraineeFormAssignees: string[];
  public MultipleTraineeFormActionType: MultipleTraineeActionType;
  public ShowPerformanceCategoryTime: boolean;
  public ShowSkillTime: boolean;
  public ShowCallTypeTime: boolean;
  public ShowSkillsThumbsUpDown: boolean;
  public ShowCallTypeThumbsUpDown: boolean;
  public EnableAttachments: boolean;
  public ShowCallNumber: boolean;
  public ShowPerformanceCategoryScores: boolean;
  public AttachmentDisclaimer: string;
  public RequireWorkflowComment: boolean;
  public RequireNextUserSelection: boolean;

  public deserialize(data: object): this {
    Object.assign(this, data);
    this.WorkDate = new Date(this.WorkDate);
    this.ShowPerformanceCategoryScores = !!data['ShowPerformanceCategoryScores'];
    return this;
  }
}
